module.exports = __webpack_public_path__ + "static/media/checklist-doodle.d1213c85.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/checklistV2/checklist-doodle.svg
// module id = 2793
// module chunks = 68